module.exports = __webpack_public_path__ + "img/06.1dec0a2a.jpg";